import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./BaseButton.module.scss.js";
const baseButtonVariants = cva(
  [
    "leading-normal inline-flex items-center justify-center whitespace-nowrap font-semibold cursor-pointer transition-all duration-200 hover:brightness-110"
  ],
  {
    variants: {
      color: {
        primary: [],
        secondary: [],
        success: [],
        danger: [],
        warning: [],
        inherit: []
      },
      variant: {
        default: [],
        shaded: [styles["shaded-elevation"]],
        outlined: [],
        text: []
      }
    },
    compoundVariants: [
      // Default
      {
        color: "primary",
        variant: "default",
        className: ["bg-primary", "text-primary-contrast"]
      },
      {
        color: "secondary",
        variant: "default",
        className: ["bg-secondary", "text-secondary-contrast"]
      },
      {
        color: "success",
        variant: "default",
        className: ["bg-success", "text-success-contrast"]
      },
      {
        color: "danger",
        variant: "default",
        className: ["bg-danger", "text-danger-contrast"]
      },
      {
        color: "warning",
        variant: "default",
        className: ["bg-warning", "text-warning-contrast"]
      },
      {
        color: "inherit",
        variant: "default",
        className: ["bg-inherit"]
      },
      // Shaded
      {
        color: "primary",
        variant: "shaded",
        className: ["bg-primary/10", "text-primary"]
      },
      {
        color: "secondary",
        variant: "shaded",
        className: ["bg-secondary/10", "text-secondary"]
      },
      {
        color: "success",
        variant: "shaded",
        className: ["bg-success/10", "text-success"]
      },
      {
        color: "danger",
        variant: "shaded",
        className: ["bg-danger/10", "text-danger"]
      },
      {
        color: "warning",
        variant: "shaded",
        className: ["bg-warning/10", "text-warning"]
      },
      // Outline
      {
        color: "primary",
        variant: "outlined",
        className: ["border border-primary", "text-primary"]
      },
      {
        color: "secondary",
        variant: "outlined",
        className: ["border border-secondary", "text-secondary"]
      },
      {
        color: "success",
        variant: "outlined",
        className: ["border border-success", "text-success"]
      },
      {
        color: "danger",
        variant: "outlined",
        className: ["border border-danger", "text-danger"]
      },
      {
        color: "warning",
        variant: "outlined",
        className: ["border border-warning", "text-warning"]
      },
      {
        color: "inherit",
        variant: "outlined",
        className: ["border border-inherit", "text-inherit"]
      },
      // Text
      {
        color: "primary",
        variant: "text",
        className: ["text-primary", "font-semibold", "hover:bg-primary/5"]
      },
      {
        color: "secondary",
        variant: "text",
        className: ["text-secondary", "font-semibold", "hover:bg-secondary/5"]
      },
      {
        color: "success",
        variant: "text",
        className: ["text-success", "font-semibold", "hover:bg-success/5"]
      },
      {
        color: "danger",
        variant: "text",
        className: ["text-danger", "font-semibold", "hover:bg-danger/5"]
      },
      {
        color: "warning",
        variant: "text",
        className: ["text-warning", "font-semibold", "hover:bg-warning/5"]
      }
    ],
    defaultVariants: {
      color: "primary",
      variant: "default"
    }
  }
);
const BaseButton = forwardRef((props, ref) => {
  const { children, variant, color, className, ...rest } = props;
  return /* @__PURE__ */ jsx("button", { ref, ...rest, className: twMerge(baseButtonVariants({ color, variant, className })), children });
});
export {
  BaseButton as default
};
//# sourceMappingURL=BaseButton.js.map
